import { Box } from '@src/atoms/Box';
import { Button } from '@src/atoms/Button';
import { ImageRenderer } from '@src/atoms/ImageRenderer';
import { Popover } from '@src/atoms/Popover';
import { Text } from '@src/atoms/Text';
import { Unit } from '@src/core/Unit';
import React, { FC } from 'react';

import styled from './OnBoardingPopover.module.scss';
import { IOnBoardingPopoverItem, IOnboardPopoverProps } from '../models';

export interface IOnBoardingPopoverProps {
  localStorageKey: string;
  open: boolean;
  onClose: () => void;
  item: IOnBoardingPopoverItem;
  anchor: HTMLElement;
  popoverProps?: IOnboardPopoverProps;
}

export const OnBoardingPopover: FC<IOnBoardingPopoverProps> = ({
  localStorageKey,
  open,
  onClose,
  anchor,
  item,
  popoverProps,
}) => {
  const { title, description, buttonUrl, buttonText, image } = item;

  return (
    <Popover open={open} anchorEl={anchor} {...popoverProps}>
      <Unit id={'OnBoardingPopover'} env={{ id: localStorageKey }}>
        <Box
          bgColor="basicWhite"
          className={styled.container}
          borderColor={'basicBlack'}
          gap={16}
          padding={16}
          alignItems={'center'}
        >
          <Box column gap={12} className={styled.textContainer}>
            <Box column gap={4}>
              <Text id={'popoverOnBoardingTitle'} weight="bold">
                {title}
              </Text>
              <Text id={'popoverOnBoardingContent'} size="secondary">
                {description}
              </Text>
            </Box>
            <Box>
              <Button id="redirectFromPopOnBoardingBtn" view="secondaryLight" href={buttonUrl} onClick={onClose}>
                {buttonText}
              </Button>
            </Box>
          </Box>
          <Box>
            <ImageRenderer url={image} className={styled.img} />
          </Box>
          <Button
            id="closeOnBoardingBtn"
            view="textLight"
            preIcon={'close'}
            className={styled.closeBtn}
            onClick={onClose}
          />
        </Box>
      </Unit>
    </Popover>
  );
};
